import Emitter from '~/utils/emitter.js'

export default {
  name: 'radio-block',
  mixins: [Emitter],
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'Big'
    }
  },
  data() {
    return {
      focus: false
    }
  },
  computed: {
    // isGroup() {
    //   let parent = this.$parent;
    //   while (parent) {
    //     if (parent.$options.componentName !== 'ElRadioGroup') {
    //       parent = parent.$parent;
    //     } else {
    //       this.radioGroup = parent;
    //       return true;
    //     }
    //   }
    //   return false;
    // },
    model: {
      get() {
        return this.isGroup ? this.radioGroup.value : this.value
      },
      set(val) {
        // if (this.isGroup) {
        //   this.dispatch('ElRadioGroup', 'input', [val]);
        // } else {
        this.$emit('input', val)
        // }
      }
    },

    haveIcon() {
      const activeSlots = Object.keys(this.$slots)
      return activeSlots.includes('svg')
    },

    elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize
    },

    radioSize() {
      const temRadioSize =
        this.size || this.elFormItemSize || (this.$ELEMENT || {}).size
      return this.isGroup
        ? this.radioGroup.radioGroupSize || temRadioSize
        : temRadioSize
    },

    isDisabled() {
      return this.isGroup
        ? this.radioGroup.disabled ||
            this.disabled ||
            (this.elForm || {}).disabled
        : this.disabled || (this.elForm || {}).disabled
    },

    tabIndex() {
      return !this.isDisabled
        ? this.isGroup
          ? this.model === this.label
            ? 0
            : -1
          : 0
        : -1
    }
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.$emit('change', this.model)
        // this.isGroup && this.dispatch('ElRadioGroup', 'handleChange', this.model);
      })
    },
    forceChange() {
      const elem = this.$refs.input
      elem.click()
    }
  }
}
